<template>
	<el-dialog :visible="visible" append-to-body width="1000px" title="高考信息完善" :close-on-click-modal="false"
		:lock-scroll="true" @close="close">
		<div v-loading="loading">
			<div class="form-section">
				<div class="form-row">
					<div class="form-row-item">
						<label class="form-label">昵称</label>
						<el-input type="text" class="form-input" v-model="formData.nickname" placeholder="昵称" />
					</div>
					<div class="form-row-item"><label class="form-label">姓名</label>
						<el-input type="text" class="form-input" v-model="formData.name" placeholder="姓名" />
					</div>
				</div>

				<div class="form-row">
					<div class="form-row-item">
						<label class="form-label">手机号</label>
						<el-input type="number" maxlength="11" class="form-input " v-model.number="formData.phone" disabled
							placeholder="手机号" />
					</div>
					<div class="form-row-item">
						<label class="form-label">性别</label>
						<el-select v-model="formData.sex" placeholder="性别">
							<el-option v-for="item in sexOpt" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
					</div>
					<div class="form-row-item">
						<label class="form-label">民族</label>
						<el-select class="" v-model="formData.nation" placeholder="民族">
							<el-option v-for="(item,index) in nationOpt" :key="index" :label="item.name"
								:value="item.name"></el-option>
						</el-select>
					</div>
				</div>

				<div class="form-row">
					<div class="form-row-item">
						<label class="form-label">高考省份</label>
						<el-select v-model="formData.province_id" placeholder="高考省份" @change="handleProvinceChange">
							<el-option v-for="item in provinceOpt" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
					</div>
					<div class="form-row-item">
						<label class="form-label">高考年份</label>
						<el-select v-model="formData.exam_year" placeholder="高考年份">
							<el-option v-for="item in yearOpt" :key="item.year" :label="item.label" :value="item.year">
							</el-option>
						</el-select>
					</div>
				</div>
				<div class="form-row">
					<div class="form-row-item">
						<label class="form-label">成绩类型</label>
						<el-select v-model="formData.score_type" placeholder="成绩类型">
							<el-option :label="formData.score_type" :value="formData.score_type"></el-option>
						</el-select>
					</div>
					<div class="form-row-item">
						<label class="form-label">我的成绩</label>
						<el-input type="number" class="form-input" min="1" max="800" v-model.number="formData.score"
							placeholder="请输入我的成绩" />
					</div>
					<div class="form-row-item">
						<label class="form-label">我的位次</label>
						<el-input type="number" class="form-input" min="1" max="10000000" v-model.number="formData.rank"
							placeholder="请输入我的位次" />
					</div>
				</div>
				<div class="form-row" v-if="formData.province_id&&modeOpt">
					<div class="form-row-item flex-start">
						<label class="form-label">选择科目
							<div>{{modeOpt.current_mode?'('+modeOpt.current_mode.name+')':''}}</div>
						</label>
						<div class="" v-if="modeOpt&&modeOpt.subjects">
							<!-- 7选3 / 3+3 模式（最多选3个） -->
							<div class="subject-group" v-if="modeOpt.current_mode.id == 1 || modeOpt.current_mode.id == 3">
								<button class="subject-tag" :class="{ active: selectedSubjects.includes(subj) }"
									@click="toggleNormalSubject(subj)" v-for="(subj,subjindex) in modeOpt.subjects.first_subjects"
									:key="subjindex">
									{{ subj.name }}
								</button>
							</div>
							<!-- 3+1+2 模式（首选1个，次选2个） -->
							<div v-if="modeOpt.current_mode.id == 2">
								<div class="margin-bottom10">首选科目（2选1）</div>
								<div class="subject-group margin-bottom20">
									<button class="subject-tag" :class="{ active: firstSubject === subj }"
										@click="selectFirstSubject(subj)" v-for="(subj,subjindex) in modeOpt.subjects.first_subjects"
										:key="subjindex">
										{{ subj.name }}
									</button>
								</div>
								<div class="margin-bottom10">次选科目（4选2）</div>
								<div class="subject-group">
									<button class="subject-tag" :class="{ active: secondSubjects.includes(subj) }"
										@click="toggleSecondSubject(subj)" v-for="(subj,subjindex) in modeOpt.subjects.second_subjects"
										:key="subjindex">
										{{ subj.name }}
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>


				<div class="form-row">
					<div class="form-row-item">
						<label class="form-label">我的身份 </label>
						<el-radio-group style="width: 500px;" v-model="formData.identity">
							<el-radio :label="item.id" v-for="(item,index) in identityOpt" :key="index">{{item.name}}</el-radio>
						</el-radio-group>
					</div>
				</div>
				<!-- 省市区三级联动 + 高中学校 -->
				<div class="form-row">
					<div class="form-row-item">
						<label class="form-label">所在区域</label>
						<div class="flex-betweenCenter">
							<!-- 省份选择 -->
							<el-select class="margin-right26 " v-model="formData.region_province_id" placeholder="省份"
								@change="handleRegionProvinceChange" clearable>
								<el-option v-for="(item,index) in regionsOpt" :key="index" :label="item.name"
									:value="item.id"></el-option>
							</el-select>
							<!-- 城市选择（依赖省份） -->
							<el-select class="margin-right26" v-model="formData.city_id" placeholder="城市" @change="handleCityChange"
								clearable :disabled="!formData.region_province_id">
								<el-option v-for="(item,index) in cityList" :key="index" :label="item.name"
									:value="item.id"></el-option>
							</el-select>
							<!-- 区县选择（依赖城市） -->
							<el-select class="margin-right26" v-model="formData.district_id" placeholder="区/县"
								@change="handleDistrictChange" clearable :disabled="!formData.city_id">
								<el-option v-for="(item,index) in districtList" :key="index" :label="item.name"
									:value="item.id"></el-option>
							</el-select>
						</div>
					</div>
				</div>
				<div class="form-row">
					<div class="form-row-item">
						<label class="form-label">所在高中</label>
						<!-- 高中选择（依赖区县） -->
						<el-select class="" v-model="formData.senior_school" placeholder="所在高中" clearable
							:disabled="!formData.district_id">
							<el-option v-for="(item,index) in seniorOpt" :key="index" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</div>
				</div>

			</div>
			<div class="flex-center">
				<ComButton name="保存信息" class="save-btn" @btnClick="saveInfo"></ComButton>
			</div>
		</div>
	</el-dialog>
</template>

<script>
	import {
		mode,
		years
	} from '@/api/volunteer'
	import {
		nation,
		regions,
		senior,
		saveexam,
		examinfo
	} from '@/api/com'
	export default {
		name: 'ChangeInfo',
		props: {
			// 弹窗显示状态
			visible: {
				type: Boolean,
				default: false
			},
		},
		data() {
			return {
				loading: true,
				infoLoading: false,
				nationOpt: [],
				provinceOpt: [],
				yearOpt: [],
				identityOpt: [],
				sexOpt: [{
						name: '请选择',
						id: 0
					},
					{
						name: '男',
						id: 1
					}, {
						name: '女',
						id: 2
					}
				],
				modeOpt: '',
				regionsOpt: [], // 省数据（一级）
				cityList: [], // 市数据（二级）
				districtList: [], // 区县数据（三级）
				seniorOpt: [], // 高中列表
				provinceName: '',
				formData: {
					id: '',
					user_id: '',
					province_id: '',
					exam_year: '',
					score_type: "普通类",
					score: '',
					rank: '',
					subject_mode: '',
					subject_first: '',
					subject_second: '',
					identity: '',
					region_province_id: '',
					city_id: '',
					district_id: '',
					region: '',
					senior_school: '',
					nickname: '',
					account: '',
					subject_first_name: [],
					subject_second_names: []
				},
				selectedSubjects: [], // 7选3/3+3 已选科目
				firstSubject: null, // 3+1+2 首选科目
				secondSubjects: [] // 3+1+2 次选科目
			}
		},
		created() {
			this.provinceOpt = JSON.parse(sessionStorage.getItem('provinceList')) || []
		},
		watch: {
			visible(newVal) {
				if (newVal) {
					this.loading = true
					this.getOpt()
						.then(async () => {
							// 获取省份ID
							const provinceId = localStorage.getItem('provinceId')
							const token = localStorage.getItem('token') || ''
							this.formInit()
							if (provinceId) {
								// 先获取考试模式，然后获取考试信息
								await this.getMode(provinceId, true, true)
							} else {
								// 如果没有省份ID，只获取考试信息（会因为没有省份ID而提前返回）
								if (token) {
									await this.getExaminfo()
								}
							}
						})
						.finally(() => {
							this.loading = false
						})
				}
			}
		},
		methods: {
			formInit() {
				this.formData = {
					id: '',
					user_id: '',
					province_id: '',
					exam_year: '',
					score_type: "普通类",
					score: '',
					rank: '',
					subject_mode: '',
					subject_first: '',
					subject_second: '',
					identity: '',
					region_province_id: '',
					city_id: '',
					district_id: '',
					region: '',
					senior_school: '',
					nickname: '',
					account: '',
					subject_first_name: [],
					subject_second_names: []
				}
			},
			async getOpt() {
				try {
					const [regionRes, yearRes, nationRes] = await Promise.all([
						regions(),
						years(),
						nation()
					])
					// 省市区数据
					this.regionsOpt = regionRes.data || []
					// 年份/身份数据
					this.yearOpt = yearRes.data.exam_years || []
					this.identityOpt = yearRes.data.identity || []
					this.nationOpt = nationRes.data || []
				} catch (err) {

					// this.$message.warning('基础数据加载失败，部分功能可能异常')
				}
			},

			// 获取用户考试信息并回显
			async getExaminfo() {
				const provinceId = localStorage.getItem('provinceId')
				// 无省份ID时不请求
				if (!provinceId) return

				try {
					const res = await examinfo({
						province_id: provinceId
					})
					const examData = res.data
					// console.log('localStorage.setItem')
					// localStorage.setItem('svip', res?.data?.is_svip || 0)

					// 赋值基础表单数据
					this.formData = {
						...this.formData,
						...examData
					}
					// 回显高考省份对应的考试模式
					if (this.formData.province_id) {
						// 如果 modeOpt 还未加载，则先加载
						if (!this.modeOpt) {
							await this.getMode(this.formData.province_id, true, false)
						} else {
							// 如果已经加载了 modeOpt，直接初始化科目选择
							this.initSubjectSelection()
						}
					}

					// 回显省市区联动数据
					this.initRegionLinkage()

					// 回显高中列表（如果有区县ID）
					if (this.formData.district_id) {
						await this.getSenior()
					}

				} catch (err) {
					// console.error('获取考试信息失败：', err)
				}
			},

			// 初始化省市区联动回显
			initRegionLinkage() {
				const {
					region_province_id,
					city_id,
					district_id
				} = this.formData

				// 加载省份对应的城市列表
				if (region_province_id) {
					const currentProvince = this.regionsOpt.find(item => item.id === region_province_id)
					if (currentProvince) {
						this.cityList = currentProvince.children || []

						// 加载城市对应的区县列表
						if (city_id) {
							const currentCity = currentProvince.children.find(item => item.id === city_id)
							if (currentCity) {
								this.districtList = currentCity.children || []
							}
						}
					}
				}
			},

			// 初始化科目选择回显
			initSubjectSelection() {
				const {
					subject_mode,
					subject_first,
					subject_second,
					subject_first_name
				} = this.formData

				// 清空原有选择
				this.selectedSubjects = []
				this.firstSubject = null
				this.secondSubjects = []

				// 无考试模式数据时直接返回
				if (!this.modeOpt || !this.modeOpt.subjects) return

				// 1. 7选3/3+3 模式（subject_mode=1/3）
				if ([1, 3].includes(subject_mode)) {
					if (subject_first) {
						const subjectIds = subject_first.split(',').map(Number)
						// 匹配科目列表，赋值到selectedSubjects
						this.selectedSubjects = this.modeOpt.subjects.first_subjects.filter(subj =>
							subjectIds.includes(subj.id)
						)
					}
				}
				// 2. 3+1+2 模式（subject_mode=2）
				else if (subject_mode === 2) {
					// 首选科目
					if (subject_first) {
						this.firstSubject = this.modeOpt.subjects.first_subjects.find(subj =>
							subj.id === Number(subject_first)
						)
					}
					// 次选科目
					if (subject_second) {
						const secondIds = subject_second.split(',').map(Number)
						this.secondSubjects = this.modeOpt.subjects.second_subjects.filter(subj =>
							secondIds.includes(subj.id)
						)
					}
				}
			},

			// 高考省份切换 - 获取考试模式（isEcho：是否为回显调用，needExamInfo：是否需要获取考试信息）
			async getMode(val, isEcho = false, needExamInfo = false) {
				this.selectedSubjects = []
				this.firstSubject = null
				this.secondSubjects = []
				this.modeOpt = null

				try {
					const res = await mode({
						province_id: val
					})
					this.modeOpt = res.data
					this.formData.subject_mode = res.data.mode

					// 如果是回显调用，重新初始化科目选择
					if (isEcho) {
						this.initSubjectSelection()
					}

					// 如果需要获取考试信息，则调用 getExaminfo
					if (needExamInfo) {
						await this.getExaminfo()
					}
				} catch (err) {
					this.modeOpt = null
					if (!isEcho) { // 回显时不弹提示，避免干扰
						this.$message.warning('获取考试模式失败，请重试')
					}
				}
			},

			// 高考省份切换处理（用户手动切换）
			async handleProvinceChange(provinceId) {
				if (!provinceId) return


				// 清空科目相关数据
				this.selectedSubjects = []
				this.firstSubject = null
				this.secondSubjects = []
				this.formData.rank = ''
				this.formData.score = ''
				this.formData.identity = ''

				this.formData.region_province_id = ''
				this.formData.city_id = ''
				this.formData.district_id = ''
				this.formData.senior_school = ''




				// 更新 formData 中的省份ID
				this.formData.province_id = provinceId

				// 清空其他可能受影响的字段
				this.formData.subject_mode = ''
				this.formData.subject_first = ''
				this.formData.subject_second = ''

				// 重新获取考试模式
				await this.getMode(provinceId, false, false)

				// 获取该省份下的考试信息
				await this.getExaminfoByProvince(provinceId)
			},

			// 根据省份ID获取考试信息
			async getExaminfoByProvince(provinceId) {
				this.infoLoading = true
				if (!provinceId) return

				try {
					const res = await examinfo({
						province_id: provinceId
					})
					const examData = res.data

					// 更新表单数据，但保留新选择的省份ID
					this.formData = {
						...this.formData,
						...examData,
						province_id: provinceId // 确保省份ID是当前选择的
					}

					// 重新初始化科目选择
					if (this.modeOpt) {
						this.initSubjectSelection()
					}

					// 回显省市区联动数据
					this.initRegionLinkage()

					// 回显高中列表（如果有区县ID）
					if (this.formData.district_id) {
						await this.getSenior()
					}
				} catch (err) {
					this.formData.score = ''
					this.formData.rank = ''
					this.formData.identity = ''
				} finally {
					this.infoLoading = false
				}
			},

			// 所属高中省份切换 - 加载对应城市列表 + 更新region
			handleRegionProvinceChange(provinceId) {
				this.formData.city_id = ''
				this.formData.district_id = ''
				this.formData.senior_school = ''
				this.formData.region = ''
				this.cityList = []
				this.districtList = []
				this.seniorOpt = []

				const currentProvince = this.regionsOpt.find(item => item.id === provinceId)
				if (currentProvince) {
					this.cityList = currentProvince.children || []
					this.formData.region = currentProvince.name
				}
			},

			// 城市切换 - 加载对应区县列表 + 更新region
			handleCityChange(cityId) {
				this.formData.district_id = ''
				this.formData.senior_school = ''
				this.districtList = []
				this.seniorOpt = []

				const currentProvince = this.regionsOpt.find(item => item.id === this.formData.region_province_id)
				if (currentProvince) {
					const currentCity = currentProvince.children.find(item => item.id === cityId)
					if (currentCity) {
						this.districtList = currentCity.children || []
						this.formData.region = `${currentProvince.name},${currentCity.name}`
					} else {
						this.formData.region = currentProvince.name
					}
				}
			},

			// 区县切换 - 加载对应高中列表 + 最终更新region
			handleDistrictChange() {
				this.formData.senior_school = ''
				this.seniorOpt = []

				if (!this.formData.region_province_id || !this.formData.city_id || !this.formData.district_id) {
					return
				}

				const currentProvince = this.regionsOpt.find(item => item.id === this.formData.region_province_id)
				const currentCity = currentProvince?.children.find(item => item.id === this.formData.city_id)
				const currentDistrict = currentCity?.children.find(item => item.id === this.formData.district_id)

				if (currentProvince && currentCity && currentDistrict) {
					this.formData.region = `${currentProvince.name},${currentCity.name},${currentDistrict.name}`
				}

				this.getSenior()
			},

			// 获取高中学校列表
			async getSenior() {
				try {
					const res = await senior({
						province_id: this.formData.region_province_id,
						city_id: this.formData.city_id,
						region_id: this.formData.district_id,
					})
					this.seniorOpt = res.data || []
					// if (this.seniorOpt.length === 0) {
					// 	this.$message.info('该区域暂无高中数据')
					// }
				} catch (err) {
					this.seniorOpt = []
					// this.$message.warning('获取高中列表失败，请重试')
				}
			},

			// 7选3/3+3 模式：切换科目
			toggleNormalSubject(subject) {
				const index = this.selectedSubjects.indexOf(subject);
				if (index > -1) {
					this.selectedSubjects.splice(index, 1);
				} else {
					if (this.selectedSubjects.length >= 3) {
						this.$message.warning('最多选择3个科目')
						return;
					}
					this.selectedSubjects.push(subject);
				}
			},

			// 3+1+2 模式：选择首选科目
			selectFirstSubject(subject) {
				this.firstSubject = this.firstSubject?.id === subject.id ? null : subject;
			},

			// 3+1+2 模式：切换次选科目
			toggleSecondSubject(subject) {
				const index = this.secondSubjects.indexOf(subject);
				if (index > -1) {
					this.secondSubjects.splice(index, 1);
				} else {
					if (this.secondSubjects.length >= 2) {
						this.$message.warning('次选科目最多选择2个')
						return;
					}
					this.secondSubjects.push(subject);
				}
			},

			// 保存信息
			async saveInfo() {
				// const submitData = {
				// 	...this.formData
				// };
				if (!this.modeOpt.current_mode) {
					this.$message.warning('请选择考试模式');
					return

				}
				let subject_first = ''
				let subject_second = ''
				// 处理科目数据
				if ([1, 3].includes(this.modeOpt.current_mode?.id)) {
					subject_first = this.selectedSubjects.map(item => item.id).join(',');
					subject_second = '';
				} else if (this.modeOpt.current_mode?.id === 2) {
					subject_first = this.firstSubject?.id || '';
					subject_second = this.secondSubjects.map(item => item.id).join(',');
				}


				// 基础校验
				if (!this.formData.province_id) {
					this.$message.warning('请选择高考省份');
					return;
				}
				if (!this.formData.exam_year) {
					this.$message.warning('请选择高考年份');
					return;
				}

				const req = {
					// province_id: submitData.province_id,
					// exam_year: submitData.exam_year,
					// score: submitData.score,
					// rank: submitData.rank,
					// subject_mode: submitData.subject_mode,
					// subject_first: submitData.subject_first,
					// subject_second: submitData.subject_second,
					// identity: submitData.identity,
					// region_province_id: submitData.region_province_id,
					// city_id: submitData.city_id,
					// district_id: submitData.district_id,
					// region: submitData.region,
					// senior_school: submitData.senior_school,
					// score_type: "普通类",
					// name: submitData.name

					nickname: this.formData.nickname,
					user_name: this.formData.name,
					sex: this.formData.sex,
					nation: this.formData.nation,
					province_id: this.formData.province_id,
					exam_year: this.formData.exam_year,
					score: this.formData.score,
					rank: this.formData.rank,
					subject_mode: this.formData.subject_mode,
					subject_first: subject_first,
					subject_second: subject_second,
					identity: this.formData.identity,
					region_province_id: this.formData.region_province_id,
					city_id: this.formData.city_id,
					district_id: this.formData.district_id,
					senior_school: this.formData.senior_school,
					region: this.formData.region,
					score_type: "普通类",

				}
				try {
					const res = await saveexam(req)
					if (res.data) {
						this.$message.success("信息保存成功")
						// localStorage.setItem('provinceName',this.provinceName)
						localStorage.setItem('provinceId', this.formData.province_id)
						window.location.href = '/'
						// this.$emit('confirm')
					}
				} catch (err) {
					this.$message.error(err)
				}
			},
			close() {
				this.formData = {}
				this.$emit('close')
			}
		}
	}
</script>

<style lang="scss" scoped>
	::v-deep {
		.el-radio__input.is-checked .el-radio__inner {
			border-color: #28b05e;
			background: #28b05e;
		}

		.el-radio__input.is-checked+.el-radio__label {
			color: #28b05e;
		}

		.el-dialog {
			border-radius: 12px;
			background: linear-gradient(to bottom, #E9F7FF 0%, #F0F8FF 20%, #FFFFFF 50%);

			&__body {
				padding: 20px;
			}
		}
	}

	.form-section {
		.form-row {
			display: grid;
			grid-template-columns: repeat(3, 1fr);
			margin-bottom: 15px;
			gap: 60px;

			.form-row-item {
				display: flex;
				justify-content: flex-start;
				align-items: center;
			}

			.form-row-item.flex-start {
				display: flex;
				justify-content: flex-start;
				align-items: flex-start;
			}

			::v-deep {
				.el-radio {
					&__label {
						font-size: 16px !important;
					}

					&__inner {
						width: 20px;
						height: 20px;

						&::after {
							width: 10px;
							height: 10px;
						}
					}
				}

				.el-select {
					min-width: 170px;
				}
			}

			.form-label {
				width: 80px;
				font-size: 16px;
				flex-shrink: 0;
			}

			.form-input {
				height: 36px;
				width: 170px;
				// padding: 0 12px;
				// border: 1px solid #ddd;
				border-radius: 4px;
				font-size: 14px;
				flex: 1;
				color: #606266;
			}

			.subject-group {
				display: flex;
				gap: 8px;
				flex-wrap: wrap;
			}

			.subject-tag {
				padding: 6px 12px;
				color: #666;
				border: 1px solid #ddd;
				border-radius: 4px;
				background-color: #fff;
				font-size: 16px;
				cursor: pointer;
				transition: all 0.2s;

				&.active {
					background-color: #28b05e;
					color: #fff;
					border-color: #28b05e;
				}
			}

			.unit {
				margin-left: 8px;
				font-size: 16px;
				color: #666;
			}



			.ml-20 {
				margin-left: 20px;
			}
		}


	}

	.save-btn {
		width: 280px;
		height: 44px;
		margin-top: 20px;
	}

	.margin-bottom10 {
		margin-bottom: 10px;
	}

	.margin-bottom20 {
		margin-bottom: 20px;
	}

	.flex-startCenter {
		display: flex;
		align-items: center;
	}

	.margin-left30 {
		margin-left: 30px;
	}
</style>
